import React, { useEffect } from "react";
import ContactForm from "./components/ContactForm";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useBoolean,
} from "@chakra-ui/react";
import Logo from "@/components/Logo";
import Footer from "./components/Footer";
import FeaturePanel from "./components/TabPanels/FeaturePanel";
import APIPanel from "./components/TabPanels/APIPanel";
import BusinessButton from "./components/BusinessButton";
import getScrollBarProps from "@/styles/scrollBarProps";
import events, { MessageType, EventCallback } from "@/utils/events";
import { useHistory } from "react-router-dom";
import { urlQueryParser } from "@/utils/tool";

const Business: React.FC = () => {
  const [formModalOpen, formModalOp] = useBoolean(false);
  const history = useHistory();
  const query = urlQueryParser(location.search);
  useEffect(() => {
    events.on(MessageType.BUSINESS_MODAL, formModalOp.on);
    return () => {
      events.off(MessageType.BUSINESS_MODAL);
    };
  }, [formModalOp]);

  const onBtnClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const t = e.target as HTMLButtonElement;
    switch (t.name) {
      case "top":
        document.getElementById("businessContainer")?.scrollTo({ top: 0 });
        break;
      case "pop":
        events.emit(MessageType.BUSINESS_MODAL);
        break;
      case "creator":
        window.open(location.origin, "_blank");
        break;
    }
  };
  return (
    <Box
      h="100vh"
      w="100vw"
      id="businessContainer"
      scrollBehavior="smooth"
      fontFamily="Source Han Sans CN"
      {...getScrollBarProps({ scrollBarWidth: 0, autoMargin: false })}
      overflowX="auto"
    >
      <Box h="100vh" w="100vw" minW="1200px" bg="#F6F9FF" pos="relative">
        <Tabs defaultIndex={query.tab === "api" ? 1 : 0}>
          <Grid
            h="64px"
            gridTemplateColumns="1fr 1fr 1fr 1fr 1fr"
            px="48px"
            bg="white"
            pos="sticky"
            top="0"
            boxShadow="0 4px 16px 0 #165DFF0E"
            zIndex={2}
          >
            <GridItem colSpan={2} display="flex" alignItems="center">
              <Logo
                size={32}
                css={{ width: "118px", cursor: "pointer" }}
                onClick={() => {
                  window.open(location.origin, "_blank");
                }}
              />
              <Text ml="0.5em" fontSize="24px" color="#165DFF" userSelect="none" fontWeight={600}>
                企业解决方案
              </Text>
            </GridItem>
            <GridItem display="flex" alignItems="center" justifyContent="center">
              <TabList h="100%" borderColor="transparent">
                <Tab
                  fontWeight={600}
                  px={0}
                  _selected={{ color: "#165DFF", borderColor: "#165DFF" }}
                  onClick={() => history.push("?tab=feature")}
                >
                  功能支持
                </Tab>
                <Tab
                  fontWeight={600}
                  px={0}
                  ml="3em"
                  _selected={{ color: "#165DFF", borderColor: "#165DFF" }}
                  onClick={() => history.push("?tab=api")}
                >
                  API服务
                </Tab>
              </TabList>
            </GridItem>
            <GridItem colSpan={2} display="flex" alignItems="center" justifyContent="flex-end">
              {/* <BusinessButton theme="white" text="体验个人版" onClick={onBtnClick} name="creator" /> */}
              <BusinessButton theme="blue" text="售前咨询" onClick={onBtnClick} name="pop" />
            </GridItem>
          </Grid>
          <TabPanels>
            <TabPanel p="0" bg="white">
              <FeaturePanel />
            </TabPanel>
            <TabPanel p="0">
              <APIPanel />
            </TabPanel>
          </TabPanels>
        </Tabs>
        <Flex
          h="258px"
          backgroundImage="url('http://nolipix-js.nolibox.com/assets/creator/footer_above_bg.png')"
          backgroundSize="cover"
          flexDir="column"
          align="center"
        >
          <Text fontSize="30px" mt="70px" fontWeight={600}>
            Nolibox AIGC，助力企业智能创意新基建
          </Text>
          <Flex mt="30px">
            <BusinessButton
              text="售前咨询"
              theme="blue"
              onClick={onBtnClick}
              icon="consult"
              name="pop"
            />
            <BusinessButton
              text="返回顶部"
              theme="white"
              onClick={onBtnClick}
              icon="arrowUp"
              name="top"
            />
          </Flex>
        </Flex>
        <Footer />
        <Modal isOpen={formModalOpen} onClose={formModalOp.off} isCentered>
          <ModalContent w="800px" h="368px">
            <ModalCloseButton />
            <ModalBody p="0">
              <Tabs
                // defaultIndex={1}
                // tabIndex={1}
                index={1}
                orientation="vertical"
                h="100%"
                boxShadow="0 2px 16px rgba(0, 0, 0, 0.1)"
              >
                {/* <TabList
                  border="none"
                  h="100%"
                  w="40px"
                  bg="#F7F8FA"
                  roundedLeft="12px"
                  color="#86909C">
                  <Tab
                    border="none"
                    h="50%"
                    _active={{}}
                    _selected={{
                      bg: "white",
                      color: "#165DFF",
                      roundedLeft: "12px",
                    }}>
                    填写表单
                  </Tab>
                  <Tab
                    border="none"
                    h="50%"
                    _active={{}}
                    _selected={{
                      bg: "white",
                      color: "#165DFF",
                      roundedLeft: "12px",
                    }}>
                    扫码联系
                  </Tab>
                </TabList> */}
                <TabPanels>
                  <TabPanel p="0">
                    <Text
                      textAlign="center"
                      color="#4E5969"
                      pt="20px"
                      fontSize="20px"
                      fontWeight={600}
                    >
                      填写信息，售前咨询，获取专属 AIGC 解决方案
                    </Text>
                    <ContactForm
                      afterSubmit={() => {
                        window.open(location.origin, "_self");
                      }}
                    />
                  </TabPanel>
                  <TabPanel p="0" h="100%" w="100%">
                    <Flex h="100%" w="100%" flexDir="column" align="center" justify="center">
                      <Text
                        textAlign="center"
                        color="#4E5969"
                        pt="20px"
                        fontSize="20px"
                        fontWeight={600}
                      >
                        扫码联系售前咨询，获取专属 AIGC 解决方案
                      </Text>
                      <Flex justify="space-between" mt="24px" w="626px">
                        <Box w="140px">
                          <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_wechat.png" />
                          <Text textAlign="center" mt="20px">
                            商务合作/销售
                          </Text>
                        </Box>
                        {/* <Box w="140px">
                          <Image src="http://nolipix-js.nolibox.com/assets/creator/business/qr_channel.png" />
                          <Text textAlign="center" mt="20px">
                            渠道/生态
                          </Text>
                        </Box> */}
                        <Box w="140px">
                          <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_dingding.png" />
                          <Text textAlign="center" mt="20px">
                            钉钉联系
                          </Text>
                        </Box>
                        <Box w="140px">
                          <Image src="http://nolipix-js.nolibox.com/assets/creator/business/contact_qrcode_feishu.png" />
                          <Text textAlign="center" mt="20px">
                            飞书联系
                          </Text>
                        </Box>
                      </Flex>
                    </Flex>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
};

export default Business;
